
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"7.5","cy":"7.5","r":"7","fill":"#0073BE","stroke":"#004A7A"}}),_c('path',{attrs:{"d":"M2.494 7.685h5.192V2.493","stroke":"#004A7A","stroke-width":"1.5","stroke-linecap":"round"}})])
          )
        }
      }
    